import Confirmation from './Confirmation.vue';

export default Confirmation;
